import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

/**
 * #123: Kennzeichen an einem Eintrag, der beim Zusammenführen aus einem anderen Projekt kam.
 * EINE Komponente für alle Stellen (Kommentare, Staffing, Briefings, Positionen, Befunde).
 * Ohne Herkunft rendert sie nichts — die Einbaustellen brauchen keine eigene Bedingung.
 */
export function HerkunftBadge({
  projectId,
  projectKey,
}: {
  projectId?: string | null | undefined;
  projectKey?: string | null | undefined;
}) {
  const { t } = useTranslation();
  if (!projectId || !projectKey) return null;
  return (
    <Link
      to={`/projects/${projectId}`}
      className="text-[10px] px-1.5 py-0.5 rounded shrink-0"
      style={{ background: 'var(--surface-2)', color: 'var(--ink-2)', fontFamily: 'var(--f-mono)' }}
      // In klickbaren Zeilen (Befund, Karte) soll der Link nicht zusätzlich die Zeile auslösen.
      onClick={(e) => e.stopPropagation()}
    >
      {t('v2.zusammenfuehren.herkunft', 'aus {{key}}', { key: projectKey })}
    </Link>
  );
}
